import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Container, Title, Image, ContainerTop } from './styles';
import 'react-tabs/style/react-tabs.css';

import Team from './team';
import Services from './services';
import Equipment from './Equipment';

import CermatIcon from '../../img/Cermat.png';

export default function ContentCenter() {
  return (
    <Container>
      <Title>Núcleo de Pesquisa em Materiais Cerâmicos e Compósitos</Title>
      <Tabs>
        <ContainerTop>
          <Image src={CermatIcon} alt="" />
          <TabList id="List">
            <Tab>Serviços</Tab>
            <Tab>Equipamentos</Tab>
            <Tab>Equipe</Tab>
          </TabList>
        </ContainerTop>
        <TabPanel>
          <Services />
        </TabPanel>

        <TabPanel>
          <Equipment />
        </TabPanel>
        <TabPanel>
          <Team />
        </TabPanel>
      </Tabs>
    </Container>
  );
}

/*
 */
